// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"2031d612d385a9f0","323":"ddd5a5c0331733da","809":"87fc0182f51f8dcd","981":"0ea89935bcb2ae40"}[chunkId] + ".js";
};